import script from "./ProductModalSide.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductModalSide.vue?vue&type=script&setup=true&lang=js"

import "./ProductModalSide.vue?vue&type=style&index=0&id=1ac126f2&lang=scss"

const __exports__ = script;

export default __exports__